import { alert } from '../../../components/Alert/tokens/diamond';
import { backDrop } from '../../../components/BackDrop/tokens/diamond';
import { badge } from '../../../components/Badge/tokens/cobalt';
import { button } from '../../../components/Button/tokens/diamond';
import { card } from '../../../components/Card/tokens/diamond';
import { coupon } from '../../../components/Coupon/tokens/cobalt';
import { input } from '../../../components/Input/tokens/diamond';
import { link } from '../../../components/Link/tokens/cobalt';
import { modal } from '../../../components/Modal/tokens/diamond';
import { popup } from '../../../components/Popup/tokens/diamond';
import { radioButton } from '../../../components/RadioButton/tokens/diamond';
import { switchTokens } from '../../../components/Switch/tokens/diamond';
import { link as deprecatedLink } from '../../../deprecated/Link/tokens/cobalt';
import { deprecatedModal } from '../../../deprecated/Modal/tokens/diamond';
import { body } from '../../../typography/Body/tokens/diamond';
import { display } from '../../../typography/Display/tokens/diamond';
import { heading } from '../../../typography/Heading/tokens/diamond';
import type { BaseComponentTokens } from '../types';
import { money } from '../../../components/Money/tokens/diamond';

export const baseComponents: BaseComponentTokens = {
  alert,
  badge,
  backDrop,
  body,
  button,
  card,
  deprecatedLink,
  deprecatedModal,
  display,
  heading,
  input,
  link,
  modal,
  money,
  popup,
  radioButton,
  coupon,
  switch: switchTokens,
};
